import { Observable } from 'rxjs';
import { Response } from '@src/core/domain/response/response';

export abstract class AlteracoesLimitesRepository {
  abstract markModalAsRead(idAlteracao: number): Observable<Response<any>>;
  abstract markDashAsRead(idAlteracao: number): Observable<Response<any>>;
}
